import { AxiosInstance, AxiosResponse } from 'axios';

import { HubspotFormBody } from '@cast/types';

const hubspotUrl = 'https://api.hsforms.com';
const firstStep =
  '/submissions/v3/integration/submit/20263710/385e6c75-a777-43b4-8ddd-05fa74cf1776';
const secondStep =
  '/submissions/v3/integration/submit/20263710/b6c89275-32dc-46f0-982b-1500041e6de1';
const reportingContactSales =
  '/submissions/v3/integration/submit/20263710/6e6fe49b-a322-45a1-bdcf-1883dbdc3085';

type HubspotApi = {
  createHubspotContact: (form: HubspotFormBody) => Promise<AxiosResponse>;
  createFullHubspotContact: (form: HubspotFormBody) => Promise<AxiosResponse>;
  submitReportingContactSales: (
    form: HubspotFormBody
  ) => Promise<AxiosResponse>;
};

export const HubspotApiFactory = (client: AxiosInstance): HubspotApi => ({
  createHubspotContact: (form) =>
    client.post(firstStep, form, { baseURL: hubspotUrl }),
  createFullHubspotContact: (form) =>
    client.post(secondStep, form, { baseURL: hubspotUrl }),
  submitReportingContactSales: (form) =>
    client.post(reportingContactSales, form, { baseURL: hubspotUrl }),
});
